import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey"; // Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Struct } from '@polkadot/types';
import runtimeTypes from '@polkadot/types/interfaces/runtime/definitions';
import { extractAuthor } from "./util.mjs"; // We can ignore the properties, added via Struct.with

var _SignedBlock = Struct.with(runtimeTypes.types.SignedBlock);

function mapExtrinsics(extrinsics, records) {
  return extrinsics.map(function (extrinsic, index) {
    var dispatchError;
    var dispatchInfo;
    var events = records.filter(function (_ref) {
      var phase = _ref.phase;
      return phase.isApplyExtrinsic && phase.asApplyExtrinsic.eq(index);
    }).map(function (_ref2) {
      var event = _ref2.event;

      if (event.section === 'system') {
        if (event.method === 'ExtrinsicSuccess') {
          dispatchInfo = event.data[0];
        } else if (event.method === 'ExtrinsicFailed') {
          dispatchError = event.data[0];
          dispatchInfo = event.data[1];
        }
      }

      return event;
    });
    return {
      dispatchError: dispatchError,
      dispatchInfo: dispatchInfo,
      events: events,
      extrinsic: extrinsic
    };
  });
}
/**
 * @name SignedBlockExtended
 * @description
 * A [[Block]] header with an additional `author` field that indicates the block author
 */


var _author = _classPrivateFieldLooseKey("author");

var _events = _classPrivateFieldLooseKey("events");

var _extrinsics = _classPrivateFieldLooseKey("extrinsics");

export var SignedBlockExtended =
/*#__PURE__*/
function (_SignedBlock2) {
  _inherits(SignedBlockExtended, _SignedBlock2);

  function SignedBlockExtended(registry, block, events, sessionValidators) {
    var _this;

    _classCallCheck(this, SignedBlockExtended);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignedBlockExtended).call(this, registry, block));
    Object.defineProperty(_assertThisInitialized(_this), _author, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _events, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _extrinsics, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _author)[_author] = extractAuthor(_this.block.header.digest, sessionValidators);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _events)[_events] = events || [];
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _extrinsics)[_extrinsics] = mapExtrinsics(_this.block.extrinsics, _classPrivateFieldLooseBase(_assertThisInitialized(_this), _events)[_events]);
    return _this;
  }
  /**
   * @description Convenience method, returns the author for the block
   */


  _createClass(SignedBlockExtended, [{
    key: "author",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _author)[_author];
    }
    /**
     * @description Convenience method, returns the events associated with the block
     */

  }, {
    key: "events",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _events)[_events];
    }
    /**
     * @description Returns the extrinsics and their events, mapped
     */

  }, {
    key: "extrinsics",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _extrinsics)[_extrinsics];
    }
  }]);

  return SignedBlockExtended;
}(_SignedBlock);